import React, { useContext } from 'react';

import clsx from 'clsx';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import FormContainer from '../FormContainer/FormContainer';
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';

import useBreakpoint from '../../hooks/useBreakpoint/useBreakpoint';

import { DataContext, DataProvider } from '../../contexts/DataContext';

import { useStyles } from './styles';
import FormNotFound from '../FormNotFound/FormNotFound';

const MainComponent = () => {
    const classes = useStyles();
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === 'xs';

    const { loading, hasErrored, error } = useContext<any>(DataContext);

    if (loading) {
        return (
            //@ts-ignore
            <ErrorBoundary errorUI={<div>Something went wrong while loading the app.</div>}>
                <LoadingScreen />
            </ErrorBoundary>
        );
    }

    //Error Handler
    if (hasErrored) {
        if (error.response?.status === 404) {
            return (
                <div
                    className={clsx({ [classes.rootMobile]: isMobile, [classes.root]: !isMobile })}
                >
                    <FormNotFound />
                </div>
            );
        }
        if (error.response?.status === 410) {
            return (
                <div
                    className={clsx({ [classes.rootMobile]: isMobile, [classes.root]: !isMobile })}
                >
                    <FormNotFound errorMessage="The form has expired" />
                </div>
            );
        }
        return <div>Error: {error.message}</div>;
    }

    // Fix for error: ErrorBoundary is not a valid JSX element.
    const ErrorBoundaryComponent = ErrorBoundary as any;
    return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
            <div className={clsx({ [classes.rootMobile]: isMobile, [classes.root]: !isMobile })}>
                <ErrorBoundaryComponent
                    //@ts-ignore
                    errorUI={<div>Something went wrong while rendering the Form.</div>}
                >
                    <FormContainer />
                </ErrorBoundaryComponent>
            </div>
        </MuiPickersUtilsProvider>
    );
};

export const Main = (props) => {
    return (
        <DataProvider>
            <MainComponent {...props} />
        </DataProvider>
    );
};
